import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getGarages, deleteGarage } from "../../../actions/admin/garage";
import Alert from "../../layout/Alert";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import AdminDeleteModal from "../_components/AdminDeleteModal";
import GarageItem from "./GarageItem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Garage Name", width: "tw:w-[220px]" },
  { key: "prefecture", title: "Prefecture", width: "tw:w-[200px]" },
  { key: "coordinates", title: "Lat, Lon", width: "tw:w-[200px]" },
  { key: "available", title: "Available", width: "tw:w-[220px]" },
  { key: "status", title: "Status", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "default", title: "Default", width: "tw:w-[160px]", skeleton: "badge" },
  { key: "action", title: "Action", width: "tw:w-[140px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const GarageList = () => {
  const garage = useSelector((state) => state.garage);
  const { loading, garages } = garage;
  const [delId, setDelId] = useState(null);
  const dispatch = useDispatch();

  // Keying this on `loading` re-ran the fetch as soon as the first one resolved.
  useEffect(() => {
    dispatch(getGarages());
  }, [dispatch]);

  const removeGarage = () => {
    dispatch(deleteGarage(delId));
    setDelId(null);
  };

  return (
    <AdminPage title="Garage List" actions={<AdminCreateButton to="/admin/addgarage" label="Add Garage" />}>
      <AdminDeleteModal
        show={!!delId}
        title="Delete this garage?"
        message="This cannot be undone."
        onCancel={() => setDelId(null)}
        onConfirm={removeGarage}
      />

      <Alert />

      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1440}
        loading={loading}
        skeletonRowCount={8}
        isEmpty={!garages?.length}
        emptyText="No garages found."
      >
        {garages?.map((item, index) => (
          <GarageItem key={item._id} garage={item} count={index} removeGarage={setDelId} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default GarageList;
